var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_admin)?_c('b-button',{staticClass:"m-r-20",attrs:{"variant":"outline-success","size":"sm"},on:{"click":_vm.export_excel}},[_c('i',{staticClass:"icon-download"}),_vm._v(" Excel ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }